import { TableCell } from '@material-ui/core'
import { withStyles, createStyles, Theme } from '@material-ui/core/styles'

const DefaultTableCellSmallSpace = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: '#2D4054',
      color: theme.palette.common.white
    },
    body: {
      textAlign: 'center',
      '&.blue': {
        backgroundColor: '#9ED6EE'
      },
      '&.grey': {
        backgroundColor: '#B6B6B6',
        color: theme.palette.common.black
      },
      '&:first-child': {
        textAlign: 'left',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        height: '35px !important',
        fontSize: 12
      }
    }
  })
)(TableCell)

export default DefaultTableCellSmallSpace
